import { render } from "./TabletHistoryModal.vue?vue&type=template&id=6ba7b68c"
import script from "./TabletHistoryModal.vue?vue&type=script&lang=js"
export * from "./TabletHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__